import './story-section.scss';
import StorySection from './StorySection';
import StorySectionHeader from './StorySectionHeader';

export { StorySectionHeader };

export default StorySection;
